import React, { useMemo } from "react";
import { useDealData, sortDealPeriods } from "contexts/DealContext";
import { usePortfolioData, sortPortfolioPeriods } from "contexts/PortfolioContext";
import { useViewMode } from "contexts/ViewModeContext";
import FinancialModelTable from "./FinancialModelTable";

const FinancialModelPage = () => {
    const { viewMode } = useViewMode();
    const {
        currentFacility: dealFacility,
        currentDealName,
        isDealLoading,
        selectedPeriod: dealSelectedPeriod,
    } = useDealData();
    const {
        currentPortfolioFacility,
        isPortfolioLoading,
        selectedPeriod: portfolioSelectedPeriod,
    } = usePortfolioData();

    const currentFacility = viewMode === 'portfolio' ? currentPortfolioFacility : dealFacility;
    const selectedPeriod = viewMode === 'portfolio' ? portfolioSelectedPeriod : dealSelectedPeriod;
    const isLoading = viewMode === 'portfolio' ? isPortfolioLoading : isDealLoading;

    const availableTimePeriods = useMemo(() => {
        if (!currentFacility?.periods) return [];
        const periods = Object.keys(currentFacility.periods);
        return viewMode === 'portfolio'
            ? sortPortfolioPeriods(periods)
            : sortDealPeriods(periods);
    }, [currentFacility, viewMode]);

    if (isLoading || !currentFacility || !selectedPeriod) {
        return (
            <div className="w-full flex justify-center items-center p-8">
                <div className="text-gray-500">
                    {isLoading
                        ? `Loading financial data for selected ${viewMode === 'portfolio' ? 'portfolio' : 'deal'}...`
                        : "Loading financial data..."}
                </div>
            </div>
        );
    }

    return (
        <div className="w-full">
            <FinancialModelTable
                availableTimePeriods={availableTimePeriods}
                currentPeriod={selectedPeriod}
            />
        </div>
    );
};

export default FinancialModelPage;
